var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c("div", { staticClass: "thumb-image" }, [
            _c(
              "div",
              { staticClass: "prop-1-1" },
              [
                _vm._t("item-image", [
                  _c("category-image-carousel", {
                    ref: "categoryImageCarousel",
                    attrs: {
                      "image-urls-data": _vm._f("itemImages")(
                        _vm.item.images,
                        _vm.imageUrlAccessor
                      ),
                      alt: _vm._f("itemName")(_vm.item),
                      title: _vm._f("itemName")(_vm.item),
                      "item-url": _vm._f("itemURL")(
                        _vm.item,
                        _vm.urlWithVariationId
                      ),
                      "enable-carousel":
                        _vm.$ceres.config.item.enableImageCarousel,
                      "disable-carousel-on-mobile": _vm.disableCarouselOnMobile
                    }
                  })
                ])
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm._t("item-details", [
            _c(
              "div",
              { staticClass: "thumb-content" },
              [
                _c(
                  "a",
                  {
                    staticClass: "thumb-title small",
                    class: {
                      "stretched-link":
                        _vm.$ceres.config.global.shippingCostsCategoryId == 0
                    },
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm._f("itemName")(_vm.item))
                    ),
                    _vm._l(_vm.item.groupedAttributes, function(attribute) {
                      return _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("translate")(
                              "Ceres::Template.itemGroupedAttribute",
                              attribute
                            )
                          )
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "thumb-meta mt-2" },
                  [
                    _vm._t("before-prices"),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xl-6 col-12 text-center text-lg-left availability-holder"
                        },
                        [
                          _vm.item.variation.availability.id < 3
                            ? _c("span", {
                                staticClass:
                                  "availability availability-1 availability-color"
                              })
                            : _c("span", {
                                staticClass:
                                  "availability availability-3 availability-color"
                              }),
                          _vm._v(" "),
                          _vm.item.variation.availability.id < 3
                            ? _c("span", { staticClass: "availability-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.item.variation.availability.names.name
                                  )
                                )
                              ])
                            : _c("span", { staticClass: "availability-text" }, [
                                _vm._v("Vorbestellt")
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.item.prices.rrp &&
                      _vm.item.prices.rrp.price.value > 0 &&
                      _vm.item.prices.rrp.price.value >
                        _vm.item.prices.default.unitPrice.value
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "prices col-xl-6 col-12 my-3 my-lg-0 text-center text-xl-right has-crossprice"
                            },
                            [
                              _vm.item.prices.rrp &&
                              _vm.item.prices.rrp.price.value > 0 &&
                              _vm.item.prices.rrp.price.value >
                                _vm.item.prices.default.unitPrice.value
                                ? _c(
                                    "div",
                                    { staticClass: "price-view-port" },
                                    [
                                      _vm.item.prices.specialOffer
                                        ? _c(
                                            "del",
                                            { staticClass: "crossprice" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm._f("itemCrossPrice")(
                                                      _vm.item.prices.default
                                                        .unitPrice.formatted,
                                                      true
                                                    )
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "del",
                                            { staticClass: "crossprice" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm._f("itemCrossPrice")(
                                                      _vm.item.prices.rrp
                                                        .unitPrice.formatted
                                                    )
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "price" },
                                [
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm._f("specialOffer")(
                                            _vm.item.prices.default.unitPrice
                                              .formatted,
                                            _vm.item.prices,
                                            "unitPrice",
                                            "formatted"
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ],
                                2
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "prices col-xl-6 col-12 my-3 my-lg-0 text-center text-xl-right"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "price" },
                                [
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm._f("specialOffer")(
                                            _vm.item.prices.default.unitPrice
                                              .formatted,
                                            _vm.item.prices,
                                            "unitPrice",
                                            "formatted"
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ],
                                2
                              )
                            ]
                          )
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("after-prices"),
                _vm._v(" "),
                !(
                  _vm.item.unit.unitOfMeasurement === "C62" &&
                  _vm.item.unit.content === 1
                )
                  ? _c("div", { staticClass: "category-unit-price small" }, [
                      _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.item.unit.names.name))
                      ]),
                      _vm._v(" "),
                      _vm.item.variation.mayShowUnitPrice
                        ? _c("span", [
                            _vm._v(
                              " | " + _vm._s(_vm.item.prices.default.basePrice)
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }